import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { FirebaseApp } from '@angular/fire/app';
import { Messaging, getMessaging, getToken } from '@angular/fire/messaging';
// import { AngularFireMessaging } from '@angular/fire/compat/messaging';
// import { mergeMapTo } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FcmService {
  private messaging: Messaging;

  constructor(private firebaseApp: FirebaseApp, @Inject(PLATFORM_ID) private platformId: Object) {
    if (isPlatformBrowser(this.platformId)) {
      this.messaging = getMessaging(this.firebaseApp);
    }
  }

  isSupported(): boolean {
    return typeof window !== 'undefined' && 
           'serviceWorker' in navigator && 
           'PushManager' in window;
  }

  async getFcmToken(): Promise<string | null> {
    if (!this.isSupported()) {
      console.error('FCM not supported in this browser');
      return null;
    }
    try {
      // Request permission for notifications (required in browsers)
      const permission = await Notification.requestPermission();
      // console.log('Notification permission:', Notification.permission);
      if (Notification.permission === 'granted') {
        // Get FCM token
        const token = await getToken(this.messaging, {
          vapidKey: "BH-wPHyYMK50lGSVSrhtFTzIjprFzX96nG0sJVMlWBcsiKzXBkNVKg-zEgpsBTMwBrafYXd-1hBKqfFuqmVCzec" // Optional (get from Firebase Console → Project Settings → Cloud Messaging)
        });
        // console.log('FCM Token:', token);
        return token;
      } else {
        console.warn('Notification permission denied');
        return null;
      }
    } catch (error) {
      console.error('Error getting FCM token:', error);
      return null;
    }
  }
}
